import Vue from "vue";
export var TopBarLoaderEventBus = new Vue();